module.exports = __webpack_public_path__ + "img/vdara6.cfbc7193.jpg";